// extracted by mini-css-extract-plugin
export default {"samples":"SampleSavedSearchesTab_samples__pjiPS","savedSearch":"SampleSavedSearchesTab_savedSearch__FseLA"};